export default class RealizedDemand {
  constructor(raw) {
    // does not really make sense to crate an object at all...
    // to stay with our patterns I'll dot it anyway
    this.realizedDemand = raw
  }
}
